import {
  DatePicker as ArkUiDatePicker,
  Portal as ArkUiPortal,
} from "@ark-ui/react";
import { Translations } from "./types";
import {
  aromaDatepicker,
  AromaDatepickerVariantProps,
} from "@zenchef/styled-system/recipes";
import Views from "./Views";

interface PortalProps extends AromaDatepickerVariantProps {
  translations: Translations;
  defaultValue: ArkUiDatePicker.RootProps["defaultValue"];
  withDoubleArrows?: boolean;
  zIndex?: string;
}

export default function Portal({
  translations,
  defaultValue,
  withDoubleArrows = true,
  zIndex = "1000",
  ...propsWithVariants
}: PortalProps) {
  const [variants] = aromaDatepicker.splitVariantProps(propsWithVariants);
  const classes = aromaDatepicker(variants);

  return (
    <ArkUiPortal>
      <ArkUiDatePicker.Positioner style={{ zIndex }}>
        <Views
          classes={classes}
          defaultValue={defaultValue}
          withDoubleArrows={withDoubleArrows}
          translations={translations}
        />
      </ArkUiDatePicker.Positioner>
    </ArkUiPortal>
  );
}
